import { NameDto } from 'api/Common/Types/NameDto'

export interface LeadDto extends LeadInvalid {
  id: string
  email: string
  tickmillCompany: {
    id: number
    name: string
    shortName: string
  }
  type: {
    id: string
    name: string
  }
  phoneNumber: string | null
  title: string | null
  firstName: string | null
  middleName: string | null
  lastName: string | null
  nativeName?: string | null
  birthDay: string
  country: {
    id: string
    name: string
  }
  language: {
    id: string
    name: string
  }
  preferredCurrency: {
    id: string
    name: string
  } | null
  externalSystems: {
    externalId: string
    externalSystem: {
      id: number
      name: string
    }
  }[]
  teams: string[]
  selected?: boolean

  products: NameDto[]
}

interface LeadInvalid {
  valid: boolean
  invalidFields: string[]
}

export enum LeadDtoKey {
  id = 'id',
  title = 'title',
  name = 'name',
  firstName = 'firstName',
  middleName = 'middleName',
  lastName = 'lastName',
  nativeName = 'nativeName',
  email = 'email',
  gender = 'gender.name',
  phoneNumber = 'phoneNumber',
  birthDay = 'birthDay',
  country = 'country.name',
  countryCode = 'countryCode',
  language = 'language.name',

  leadSource = 'leadSource.name',
  leadSourceDescription = 'leadSourceDescription',
  tickmillCompany = 'tickmillCompany.name',
  type = 'type.name',

  optIn = 'optIn',
  emailVerified = 'emailVerified',
  phoneVerified = 'phoneVerified',
  isUsCitizen = 'isUsCitizen',
  isConverted = 'isConverted',

  campaign = 'campaign',
  campaignSource = 'campaignSource',
  campaignMedium = 'campaignMedium',
  campaignTerm = 'campaignTerm',
  campaignContent = 'campaignContent',

  referrer = 'referrer',
  referralCode = 'referralCode',
  sglAgent = 'SglAgent.name',

  city = 'city',
  address = 'address',
  state = 'state',
  postalCode = 'postalCode',

  teams = 'teams',
  assignee = 'assignee.name',
  externalSystems = 'externalSystems',
  preferredCurrency = 'preferredCurrency',

  created = 'created',
  updated = 'updated',

  products = 'products',
}

export enum LeadDtoFilterKey {
  email = 'Email',
  tickmillCompany = 'TickmillCompany',
  phoneNumber = 'PhoneNumber',
  firstName = 'FirstName',
  lastName = 'LastName',
  nativeName = 'nativeName',
  country = 'Country',
  converted = 'Converted',
  assignee = 'Assignee',
  createdDate = 'DateCreated',
  updatedDate = 'DateUpdated',
}
